module.exports = __webpack_public_path__ + "src/assets/animations/tree.txt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animations/tree.txt
// module id = ./src/assets/animations/tree.txt
// module chunks = 0